import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

const loginFormSchema = toFormikValidationSchema(
    z.object({
        email: z.email("Login.Error_Email_Invalid").min(1, "Login.Error_Email_Required"),
        password: z.string("Login.Error_Password_Required"),
    }),
);

export default loginFormSchema;
